export class ApplicationError extends Error {
  constructor(
    message: string,
    public readonly key?: string
  ) {
    super(message);
    this.name = "ApplicationError";
  }
}
